module.exports = __webpack_public_path__ + "static/media/liveness.3c8e81d5.gif";